import * as RechartsPrimitive from "recharts"

const ChartLine = RechartsPrimitive.Line

export default ChartLine
